(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(7187);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qj": function() { return /* binding */ LinkButton; },
/* harmony export */   "kz": function() { return /* binding */ LinkButtonAnimated; },
/* harmony export */   "lr": function() { return /* binding */ ButtonNormalized; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  position: relative;\n  appearance: none;\n  user-select: none;\n  color: #000;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 2px solid;\n  border-color: inherit;\n\n  padding: 0.5em 1em;\n  margin: var(--size-2);\n\n  color: inherit;\n  font-family: var(--font-family-sans-serif);\n  font-weight: bold;\n  font-size: 0.8em;\n  ",
        ";\n\n  transition: all ease 0.5s;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:active {\n    background: rgba(0, 0, 0, 0.2);\n    padding-left: 1.3em;\n    padding-right: 1.3em;\n    margin-left: calc(var(--size-2) - 0.3em);\n    margin-right: calc(var(--size-2) - 0.3em);\n  }\n\n  @media (any-pointer: fine) {\n    &:hover {\n      background: rgba(0, 0, 0, 0.2);\n      padding-left: 1.3em;\n      padding-right: 1.3em;\n      margin-left: calc(var(--size-2) - 0.3em);\n      margin-right: calc(var(--size-2) - 0.3em);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  color: #fff;\n  border-color: #fff;\n\n  &:visited,\n  &:link {\n    color: #fff;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var ButtonNormalized = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-e6a8b475-0"
})(_templateObject());
var baseStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
});
var animated = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2());
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(ButtonNormalized).withConfig({
    componentId: "sc-e6a8b475-1"
})(_templateObject3(), baseStyling, animated);
var LinkButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-e6a8b475-2"
})(_templateObject4(), baseStyling);
var LinkButtonAnimated = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(LinkButton).withConfig({
    componentId: "sc-e6a8b475-3"
})(_templateObject5(), animated);


/***/ }),

/***/ 4675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DisplayAbove */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  ",
        " {\n    display: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var DisplayAbove = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-921e81d2-0"
})(_templateObject(), function(param) {
    var theme = param.theme, breakpoint = param.breakpoint;
    var ref;
    return (ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref[breakpoint];
}, function(param) {
    var display = param.display;
    return display !== null && display !== void 0 ? display : "block";
});
/* harmony default export */ __webpack_exports__["Z"] = (DisplayAbove);


/***/ }),

/***/ 1138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DisplayBelow */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var DisplayBelow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-1c97c667-0"
})(_templateObject(), function(param) {
    var display = param.display;
    return display !== null && display !== void 0 ? display : "block";
}, function(param) {
    var theme = param.theme, breakpoint = param.breakpoint;
    var ref;
    return (ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref[breakpoint];
});
/* harmony default export */ __webpack_exports__["Z"] = (DisplayBelow);


/***/ }),

/***/ 7015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Heading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9521);
/* harmony import */ var _utils_sanitize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2938);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7557);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_4__);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n  \n  font-family: var(--text-",
        "-font-family);\n  font-style: var(--text-",
        "-font-style);\n  font-size: var(--text-",
        "-font-size);\n\n  text-transform: ",
        ";\n\n  line-height: ",
        ";\n\n  font-weight: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledHeading = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ee10527e-0"
})(_templateObject(), function(param) {
    var trimmed = param.trimmed;
    return trimmed ? "\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n    padding-right: 2px;\n  " : "";
}, function(param) {
    var maxLines = param.maxLines;
    return maxLines ? "\n      overflow: hidden;\n      text-overflow: ellipsis;\n      -moz-box-orient: vertical;\n      display: -webkit-box;\n      -webkit-line-clamp: ".concat(maxLines, ";\n      -webkit-box-orient: vertical;\n  ") : "";
}, function(param) {
    var noWrap = param.noWrap;
    return noWrap ? "\n        white-space: nowrap;\n      " : "";
}, function(param) {
    var heading = param.heading;
    return heading;
}, function(param) {
    var heading = param.heading;
    return heading;
}, function(param) {
    var heading = param.heading;
    return heading;
}, function(param) {
    var textTransform = param.textTransform, heading = param.heading;
    return textTransform ? textTransform : "var(--text-".concat(heading, "-text-transform)");
}, function(param) {
    var lineHeight = param.lineHeight, heading = param.heading;
    return lineHeight ? lineHeight : "var(--text-".concat(heading, "-line-height)");
}, function(param) {
    var fontWeight = param.fontWeight, heading = param.heading;
    return fontWeight ? fontWeight : "var(--text-".concat(heading, "-font-weight)");
}, function(param) {
    var inline = param.inline, heading = param.heading;
    return !inline ? "\n        margin: var(--text-".concat(heading, "-margin-top) 0\n        var(--text-").concat(heading, "-margin-bottom)\n        var(--text-").concat(heading, "-margin-left);\n      ") : "";
});
var Heading = function(props) {
    var sanitizedHtml = !props.children && props.html ? {
        __html: (0,_utils_sanitize__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props.html)
    } : undefined;
    var headingProps = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, lodash_omit__WEBPACK_IMPORTED_MODULE_4___default()(props, [
        "children",
        "html",
        "asTag"
    ]));
    if (props.asTag) {
        if (props.heading === "h0" || props.heading === "h1" || props.asTag === "h1") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeading, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                as: "h1"
            }, headingProps), {
                dangerouslySetInnerHTML: sanitizedHtml,
                children: !sanitizedHtml ? props.children : undefined
            }));
        }
        if (props.heading === "h2" || props.asTag === "h2") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeading, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                as: "h2"
            }, headingProps), {
                dangerouslySetInnerHTML: sanitizedHtml,
                children: !sanitizedHtml ? props.children : undefined
            }));
        }
        if (props.heading == "h3" || props.asTag === "h3") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeading, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                as: "h3"
            }, headingProps), {
                dangerouslySetInnerHTML: sanitizedHtml,
                children: !sanitizedHtml ? props.children : undefined
            }));
        }
        if (props.heading == "h4" || props.asTag === "h4") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeading, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                as: "h4"
            }, headingProps), {
                dangerouslySetInnerHTML: sanitizedHtml,
                children: !sanitizedHtml ? props.children : undefined
            }));
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeading, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, headingProps), {
        dangerouslySetInnerHTML: sanitizedHtml,
        children: !sanitizedHtml ? props.children : undefined
    }));
};


/***/ }),

/***/ 3427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SafeHtmlDiv */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_sanitize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2938);



var SafeHtmlDiv = function(param) {
    var html = param.html, style = param.style;
    if (typeof html !== "string") return html;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: style,
        dangerouslySetInnerHTML: {
            __html: (0,_utils_sanitize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(html)
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafeHtmlDiv);


/***/ }),

/***/ 54:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SafeHtmlSpan */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_sanitize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2938);



var SafeHtmlSpan = function(param) {
    var html = param.html;
    if (typeof html !== "string") return html;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        dangerouslySetInnerHTML: {
            __html: (0,_utils_sanitize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(html)
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafeHtmlSpan);


/***/ }),

/***/ 7187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-head-seo/dist/index.module.js
var index_module = __webpack_require__(4058);
// EXTERNAL MODULE: ./components/layouts/LayoutMain.tsx + 1 modules
var LayoutMain = __webpack_require__(2518);
// EXTERNAL MODULE: ./components/app/Header.tsx + 4 modules
var Header = __webpack_require__(7141);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/react-typing-effect/dist/index.js
var dist = __webpack_require__(6503);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/ui/AnimatedArrow.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  to {\n    stroke-dashoffset: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n\n  transform-origin: center center;\n\n  // down to left\n  ",
        "\n\n  // down to right\n  ",
        "\n\n  // up to right away\n  ",
        "\n\n  // down to right away\n  ",
        "\n\n  // down to bottom middle (mobile)\n  ",
        "\n    \n    \n  // the & is important as it makes sure that anything is only applied to this instance\n  & svg {\n    opacity: ",
        ";\n    .draw-arrow {\n      stroke-width: 1;\n      stroke: #9f9f9f;\n      fill: none;\n      stroke-dasharray: 400;\n      stroke-dashoffset: 400;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n      animation-duration: 1s;\n      animation-delay: ",
        ";\n      animation-fill-mode: forwards;\n      animation-name: ",
        ";\n\n      &.st0 {\n        stroke-width: 1;\n        stroke: #aaa;\n      }\n\n      &.tail-1 {\n        animation-delay: ",
        ";\n        animation-fill-mode: forwards;\n      }\n      &.tail-2 {\n        animation-delay: ",
        ";\n        animation-fill-mode: forwards;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var drawAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3ffd228-0"
})(_templateObject1(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var towards = param.towards, bend = param.bend;
    return towards && bend === "down left" ? "\n    transform: rotate(65deg) translate(-4px,20px);\n    " : "";
}, function(param) {
    var towards = param.towards, bend = param.bend;
    return towards && bend === "down right" ? "\n    transform: rotate(-59deg) translate(16px,30px) scaleX(-1);\n    " : "";
}, function(param) {
    var towards = param.towards, bend = param.bend;
    return towards === undefined && bend === "up right" ? "\n    transform: rotate(35deg) translate(28px,-11px) scaleY(-1);\n    " : "";
}, function(param) {
    var towards = param.towards, bend = param.bend;
    return towards === undefined && bend === "down right" ? "\n    transform-origin: bottom right;\n    transform: rotate(-82deg) translate(-72%,100%) scaleX(-1);\n    " : "";
}, function(param) {
    var towards = param.towards, bend = param.bend;
    return towards === undefined && bend === "down below" ? "\n    transform-origin: bottom right;\n    transform: rotate(-12deg) translate(-51%,114%) scale(0.7) scaleX(-1);\n    " : "";
}, function(param) {
    var animate = param.animate;
    return animate ? 1 : 0;
}, function(param) {
    var animationDelay = param.animationDelay;
    return animationDelay ? "".concat(animationDelay === null || animationDelay === void 0 ? void 0 : animationDelay.toFixed(1), "s") : "0s";
}, function(param) {
    var animate = param.animate;
    return animate ? drawAnimation : "none";
}, function(param) {
    var animationDelay = param.animationDelay;
    var ref;
    return animationDelay ? "".concat((ref = animationDelay + 0.5) === null || ref === void 0 ? void 0 : ref.toFixed(1), "s") : "0.5s";
}, function(param) {
    var animationDelay = param.animationDelay;
    var ref;
    return animationDelay ? "".concat((ref = animationDelay + 0.7) === null || ref === void 0 ? void 0 : ref.toFixed(1), "s") : "0.7s";
});
var AnimatedArrow = function(param) {
    var _width = param.width, width = _width === void 0 ? "100%" : _width, _height = param.height, height = _height === void 0 ? "100%" : _height, towards = param.towards, _bend = param.bend, bend = _bend === void 0 ? "bottom left" : _bend, animate = param.animate, animationDelay = param.animationDelay;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        width: width,
        height: height,
        animate: animate,
        bend: bend,
        towards: towards,
        animationDelay: animationDelay,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 43.1 85.9",
            xmlSpace: "preserve",
            width: "100%",
            height: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    className: "draw-arrow st0",
                    d: "M 6 2 C 4.093 8.472 1.625 23.453 9 43 C 13.922 55.547 24.782 68.68 36.943 78.755 M 6 2 C 4.093 8.472 1.625 23.453 9 43 C 13.08 53.695 21.836 68.511 36.6 79"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    className: "draw-arrow tail-1",
                    d: "M 37 79 C 36.685 72.607 36.685 72.607 36.068 67.494 M 36.451 78.347 C 36.244 72.431 36.244 71.197 36.156 67.759 "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    className: "draw-arrow tail-2",
                    d: "M 37.046 79.065 C 31.925 79.464 32.47 79.246 24.989 79.392 M 36.013 78.632 C 31.744 79.174 32.288 79.21 25.025 79.392"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/content/Wizard.tsx

function Wizard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n"
    ]);
    Wizard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Wizard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: auto;\n"
    ]);
    Wizard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: ",
        ";\n  bottom: ",
        ";\n  top: ",
        ";\n\n  left: ",
        ";\n  display: inline-block;\n  height: 120px;\n  width: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: ",
        ";\n  ",
        "\n  opacity: 0;\n\n  // opacity: ",
        ";\n\n  // transition: all 1sec ease;\n  animation-duration: 1s;\n  animation-delay: ",
        ";\n  animation-fill-mode: forwards;\n  animation-name: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




// import { AnimatedArrow } from "~/components/ui/AnimatedArrow";

// import { SvgBackground } from "../ui/SvgBackground";
// import Arrow from "~/assets/svg/original/Arrow.svg"
var blendIn = (0,styled_components_browser_esm/* keyframes */.F4)(Wizard_templateObject());
var WizAnchor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ee7df160-0"
})(Wizard_templateObject1());
var WizContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ee7df160-1"
})(_templateObject2(), function(param) {
    var position = param.position;
    return position;
}, function(param) {
    var bottom = param.bottom;
    return bottom !== null && bottom !== void 0 ? bottom : "0";
}, function(param) {
    var top = param.top;
    return top !== null && top !== void 0 ? top : "auto";
}, function(param) {
    var left = param.left;
    return left !== null && left !== void 0 ? left : "0";
}, function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "100%";
});
var WizText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ee7df160-2"
})(_templateObject3(), function(param) {
    var right = param.right;
    return right ? "right" : "left";
}, function(param) {
    var theme = param.theme;
    return theme.applyMixin("monospace");
}, function(param) {
    var animate = param.animate;
    return animate ? 1 : 0;
}, function(param) {
    var animationDelay = param.animationDelay;
    return animationDelay ? "".concat(animationDelay === null || animationDelay === void 0 ? void 0 : animationDelay.toFixed(1), "s") : "0s";
}, function(param) {
    var animate = param.animate;
    return animate ? blendIn : "none";
});
var Wizard = function(param) {
    var towards = param.towards, right = param.right, bend = param.bend, width = param.width, left = param.left, bottom = param.bottom, top = param.top, _position = param.position, position = _position === void 0 ? "absolute" : _position, children = param.children, inView = param.inView, inViewDelay = param.inViewDelay, inViewRevert = param.inViewRevert;
    var inViewObserver = (0,react_intersection_observer/* useInView */.YD)({
        fallbackInView: true
    });
    var ref = (0,react.useState)(!!!inView), isInView = ref[0], setIsInView = ref[1];
    (0,react.useEffect)(function() {
        if (false) {}
        if (inViewObserver.inView) {
            setIsInView(true);
        } else if (isInView && inViewRevert) {
            setIsInView(false);
        }
    }, [
        inViewObserver.inView,
        isInView,
        inViewRevert
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WizAnchor, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WizContainer, {
            width: width,
            left: left,
            position: position,
            bottom: bottom,
            top: top,
            ref: inViewObserver.ref,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedArrow, {
                    animate: isInView,
                    animationDelay: inViewDelay !== null && inViewDelay !== void 0 ? inViewDelay : 0,
                    bend: bend,
                    towards: towards
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WizText, {
                    animate: isInView,
                    animationDelay: inViewDelay !== null && inViewDelay !== void 0 ? inViewDelay : 0,
                    right: right,
                    children: children
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/state/CssVarsState.tsx
var CssVarsState = __webpack_require__(9479);
// EXTERNAL MODULE: ./components/ui/SafeHtmlSpan.tsx
var SafeHtmlSpan = __webpack_require__(54);
;// CONCATENATED MODULE: ./components/content/Intro.tsx

function Intro_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  // margin-top: var(--size-7);\n  display: flex;\n  flex-direction: column;\n  height: 60vh;\n  min-height: 400px;\n\n  ",
        " {\n    height: 70vh;\n  }\n"
    ]);
    Intro_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Intro_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin: auto auto var(--size-4);\n  width: 80%;\n  ",
        ";\n\n  font-weight: 700;\n\n  ",
        " {\n    margin: auto auto var(--size-2);\n    font-weight: 400;\n  }\n"
    ]);
    Intro_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Intro_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto auto;\n  width: 80%;\n  max-width: 800px;\n  display: flex;\n  justify-content: center;\n  align-items: start;\n\n  ",
        ";\n\n  font-size: 1.1em;\n  line-height: 1.3em;\n  height: fit-content;\n  min-height: 4em;\n\n  ",
        " {\n    height: var(--size-6);\n    min-height: none;\n    font-size: 1.3em;\n  }\n"
    ]);
    Intro_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Intro_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dbae0e5a-0"
})(Intro_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var StyledHeading = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-dbae0e5a-1"
})(Intro_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.textStyle("h0");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var Typing = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dbae0e5a-2"
})(Intro_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.applyMixin("monospace");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var Intro = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var isTabletAndUp = (0,CssVarsState/* useCssVarsStateIsTabletAndUpState */.kH)();
    var ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlSpan/* default */.Z, {
                    html: (ref7 = data === null || data === void 0 ? void 0 : (ref = data.acf) === null || ref === void 0 ? void 0 : (ref1 = ref.pageHero) === null || ref1 === void 0 ? void 0 : ref1.introQuestion) !== null && ref7 !== void 0 ? ref7 : ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typing, {
                children: (data === null || data === void 0 ? void 0 : (ref2 = data.acf) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageHero) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.introAnswers) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                    text: data.acf.pageHero.introAnswers.map(function(answer) {
                        return answer.answer;
                    }),
                    speed: 80,
                    eraseSpeed: 20,
                    eraseDelay: 3000,
                    typingDelay: 500
                })
            }),
            isTabletAndUp && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wizard, {
                        towards: true,
                        bend: "down left",
                        left: "5%",
                        bottom: "100px",
                        width: "30%",
                        inView: true,
                        inViewDelay: 1.0,
                        inViewRevert: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlSpan/* default */.Z, {
                            html: data === null || data === void 0 ? void 0 : (ref5 = data.acf) === null || ref5 === void 0 ? void 0 : ref5.wizardLeft
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wizard, {
                        towards: true,
                        right: true,
                        bend: "down right",
                        left: "60%",
                        bottom: "100px",
                        width: "35%",
                        inView: true,
                        inViewDelay: 2.5,
                        inViewRevert: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlSpan/* default */.Z, {
                            html: data === null || data === void 0 ? void 0 : (ref6 = data.acf) === null || ref6 === void 0 ? void 0 : ref6.wizardRight
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/content/Tile.tsx

function Tile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: var(--size-4);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  color: white;\n  position: relative;\n"
    ]);
    Tile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Tile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  mix-blend-mode: multiply;\n\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: 0;\n"
    ]);
    Tile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Tile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 2em;\n  margin-bottom: var(--size-5);\n  z-index: 1;\n"
    ]);
    Tile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Tile_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  text-align: center;\n  flex: auto 1 1;\n  display: flex;\n  flex-direction: column;\n  background: rgba(0, 0, 0, 0.55);\n  // background-blend-mode: multiply;\n  mix-blend-mode: none;\n\n  padding: var(--size-6) var(--size-4);\n  ",
        " {\n    padding: var(--size-5) var(--size-6) var(--size-4);\n  }\n"
    ]);
    Tile_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n  color: white;\n\n  font-weight: bold;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.85em;\n  line-height: 1.2em;\n\n  flex: auto 0 0;\n  margin: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: auto 0 0;\n  display: flex;\n  justify-content: center;\n  \n  & a {\n    align-self: flex-end;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var TileContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3621fbb-0"
})(Tile_templateObject());
var TileOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3621fbb-1"
})(Tile_templateObject1(), function(param) {
    var theme = param.theme, bgColor = param.bgColor;
    return theme.color(bgColor, 0.6);
});
var TileElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3621fbb-2"
})(Tile_templateObject2());
var TileContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3621fbb-3"
})(Tile_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var TileHeadline = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-d3621fbb-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.textStyle("h3");
}, function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
});
var TileText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3621fbb-5"
})(_templateObject5());
var TileButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3621fbb-6"
})(_templateObject6());
var Tile = function(param) {
    var bgOverlay = param.bgOverlay, element = param.element, headline = param.headline, id = param.id, buttons = param.buttons, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileContainer, {
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TileOverlay, {
                bgColor: bgOverlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TileElement, {
                children: element
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TileHeadline, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlSpan/* default */.Z, {
                            html: headline
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TileText, {
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TileButtons, {
                        children: buttons
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/styled/Button.tsx
var Button = __webpack_require__(5301);
// EXTERNAL MODULE: ./components/app/Logo.tsx
var Logo = __webpack_require__(7963);
// EXTERNAL MODULE: ./components/ui/LabElement.tsx
var LabElement = __webpack_require__(7656);
;// CONCATENATED MODULE: ./assets/img/globe.jpg
/* harmony default export */ var globe = ({"src":"/_next/static/media/globe.f198d73a.jpg","height":2320,"width":2345,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAAowf/xAAdEAACAgEFAAAAAAAAAAAAAAABBAIREgADBlGy/9oACAEBAAE/AFuQRmwVzmXjv410L81r/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAgBAgEBPwB//8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAgBAwEBPwB//9k=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./components/ui/SafeHtmlDiv.tsx
var SafeHtmlDiv = __webpack_require__(3427);
// EXTERNAL MODULE: ./providers/ConfigContextProvider.tsx
var ConfigContextProvider = __webpack_require__(5547);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/scrollToHash.ts + 1 modules
var scrollToHash = __webpack_require__(2856);
;// CONCATENATED MODULE: ./components/content/Tiles.tsx

function Tiles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n\n  background: url(",
        ");\n  background-blend-mode: multiply;\n  background-size: cover;\n  background-color: white;\n  background-position: top left;\n\n  ",
        " {\n    background-position: top center;\n    grid-template-columns: 50% 50%;\n  }\n"
    ]);
    Tiles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-466dd05c-0"
})(Tiles_templateObject(), function(props) {
    return props.bg;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
});
var createButtons = function(links, scope, id) {
    if (links === null || links === void 0 ? void 0 : links.length) {
        return links.map(function(link, index) {
            if (!(link === null || link === void 0 ? void 0 : link.url) || link.url.trim() === "") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
            var target = undefined;
            var rel = undefined;
            var onClick = undefined;
            if ((link === null || link === void 0 ? void 0 : link.newTab) === true) {
                target = "_blank";
                rel = "norefferer";
            }
            if (link.url.indexOf("#") > -1) {
                onClick = function(event) {
                    event.preventDefault();
                    (0,scrollToHash/* scrollToHash */.p)(link.url);
                };
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: link.url,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* LinkButtonAnimated */.kz, {
                    rel: rel,
                    target: target,
                    onClick: onClick,
                    children: link.label
                })
            }, "tile-tile-button-".concat(scope, "-").concat(id, "-").concat(index));
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var Tiles = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var config = (0,ConfigContextProvider/* useConfigContext */.q)();
    var id = (0,react.useId)();
    var tool = config.tools.find(function(tool) {
        var ref, ref1;
        return tool.slug === (data === null || data === void 0 ? void 0 : (ref = data.acf) === null || ref === void 0 ? void 0 : (ref1 = ref.tileLeft) === null || ref1 === void 0 ? void 0 : ref1.toolSlug);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
        bg: globe.src,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, {
                bgOverlay: "piaiMap",
                element: tool ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LabElement/* LabElement */.c, {
                    shortHandle: tool.iconShort,
                    longText: tool.iconLong,
                    color: "white",
                    hoverColor: "#ffffff"
                }, "tiles-tile-left-logo-".concat(id)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                headline: data === null || data === void 0 ? void 0 : (ref = data.acf) === null || ref === void 0 ? void 0 : (ref1 = ref.tileLeft) === null || ref1 === void 0 ? void 0 : ref1.title,
                buttons: createButtons(data === null || data === void 0 ? void 0 : (ref2 = data.acf) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.tileLeft) === null || ref3 === void 0 ? void 0 : ref3.links, "left", id),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlDiv/* default */.Z, {
                    html: data === null || data === void 0 ? void 0 : (ref4 = data.acf) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.tileLeft) === null || ref5 === void 0 ? void 0 : ref5.teaser
                }, "tiles-tile-left-html-".concat(id))
            }, "tiles-tile-left-".concat(id)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, {
                bgOverlay: "piaiInterface",
                element: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {
                    color: "white",
                    hoverColor: "white"
                }, "tiles-tile-right-logo-".concat(id)),
                headline: data === null || data === void 0 ? void 0 : (ref6 = data.acf) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.tileRight) === null || ref7 === void 0 ? void 0 : ref7.title,
                buttons: createButtons(data === null || data === void 0 ? void 0 : (ref8 = data.acf) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.tileRight) === null || ref9 === void 0 ? void 0 : ref9.links, "right", id),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlDiv/* default */.Z, {
                    html: data === null || data === void 0 ? void 0 : (ref10 = data.acf) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.tileRight) === null || ref11 === void 0 ? void 0 : ref11.teaser
                }, "tiles-tile-right-html-".concat(id))
            }, "tiles-tile-right-".concat(id))
        ]
    });
};

// EXTERNAL MODULE: ./components/styled/DisplayAbove.tsx
var DisplayAbove = __webpack_require__(4675);
// EXTERNAL MODULE: ./components/styled/DisplayBelow.tsx
var DisplayBelow = __webpack_require__(1138);
// EXTERNAL MODULE: ./components/ui/Heading.tsx
var Heading = __webpack_require__(7015);
// EXTERNAL MODULE: ./components/ui/PageMargins.tsx
var PageMargins = __webpack_require__(9943);
// EXTERNAL MODULE: ./components/ui/SvgBackground.tsx + 5 modules
var SvgBackground = __webpack_require__(1147);
;// CONCATENATED MODULE: ./components/content/Accessible.tsx

function Accessible_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  padding-right: 0em;\n\n  ",
        " {\n    padding-right: 4em;\n  }\n"
    ]);
    Accessible_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Accessible_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: 0;\n  right: 0;\n  display: block;\n  background: rgba(255, 255, 255, 0.85);\n  padding: 10px 20px 10px 5px;\n  margin-top: -6px;\n  border-radius: 20px;\n  text-align: right;\n  opacity: 0.3;\n\n  ",
        " {\n    position: absolute;\n    opacity: 1;\n  }\n\n  &:hover {\n    background: yellow;\n  }\n\n  & > span:first-child {\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    max-width: auto;\n    margin: 0 1em;\n    transition: max-width 0.5s ease;\n\n    ",
        ";\n\n    ",
        " {\n      max-width: 0;\n      margin: 0;\n    }\n  }\n\n  &:hover > span:first-child {\n    // opacity: 1;\n    max-width: 200px;\n    margin: 0 1em;\n  }\n\n  & > span:last-child {\n    display: inline-block;\n    height: 1.5em;\n    width: 1.5em;\n\n    & .svg {\n      position: relative;\n      top: 2px;\n    }\n  }\n"
    ]);
    Accessible_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Accessible_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  // flex-direction: column-reverse;\n  flex-direction: column;\n\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    Accessible_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var AccessibleText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a1d4fd06-0"
})(Accessible_templateObject(), function(param) {
    var simple = param.simple;
    return simple ? "400" : "inherit";
}, function(param) {
    var simple = param.simple;
    return simple ? "1.1em" : "inherit";
}, function(param) {
    var simple = param.simple;
    return simple ? "1.4em" : "inherit";
}, function(param) {
    var simple = param.simple;
    return simple ? "#000" : "inherit";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var Icon = (0,styled_components_browser_esm/* default */.ZP)(Button/* ButtonNormalized */.lr).withConfig({
    componentId: "sc-a1d4fd06-1"
})(Accessible_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var AccessibleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a1d4fd06-2"
})(Accessible_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var Accessible = function(param) {
    var simple = param.simple, _position = param.position, position = _position === void 0 ? "top right" : _position, _defaultToSimple = param.defaultToSimple, defaultToSimple = _defaultToSimple === void 0 ? false : _defaultToSimple, children = param.children;
    // TODO: Write toggle function depending on toggle or global state/envirnoment variable
    var ref = (0,react.useState)(defaultToSimple), isSimple = ref[0], setIsSimple = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccessibleContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccessibleText, {
                simple: isSimple,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlSpan/* default */.Z, {
                    html: isSimple ? simple : children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Icon, {
                onClick: function() {
                    return setIsSimple(!isSimple);
                },
                "aria-label": "change to simple language",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: isSimple ? "Show standard language" : "Show simplified language"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgBackground/* SvgBackground */.K, {
                            type: "language"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ui/JumpAnchor.tsx


var JumpAnchor = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id
    });
};

;// CONCATENATED MODULE: ./components/content/TextSection.tsx

function TextSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n\n  // auf mobiles stacken wir dir columns\n  grid-template-rows: auto auto;\n  gap: var(\n    --size-gutter-width\n  ); // <-- immer gut etwas luft zischen den spalten/reihen zu haben\n\n  margin: 0 0 var(--size-6);\n  position: relative;\n\n  // ab tablets gibt es dann genug platz um die spalten\n  ",
        " {\n    // <!-- so kann man breakpoints innerhalb einer styled component verwenden. Alles in den klammern wird nur ab dieser gr\xf6\xdfe dargestellt.\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 2fr;\n  }\n"
    ]);
    TextSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TextSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: var(--size-7) var(--size-2);\n  text-align: center;\n  font-weight: bold;\n\n  ",
        " {\n    margin: var(--size-6);\n  }\n"
    ]);
    TextSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TextSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    overflow: hidden;\n    padding-bottom: 100px;\n    align-self: stretch;\n  }\n"
    ]);
    TextSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var TextSection_Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4de71b1b-0"
})(TextSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var SectionHeading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* Heading */.X).withConfig({
    componentId: "sc-4de71b1b-1"
})(TextSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var GridLeftColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4de71b1b-2"
})(TextSection_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var TextSection = function(param) {
    var data = param.data, id = param.id;
    var ref, ref1, ref2, ref3;
    var isTabletAndUp = (0,CssVarsState/* useCssVarsStateIsTabletAndUpState */.kH)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JumpAnchor, {
                id: id
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMargins/* default */.ZP, {
                spaceBottom: 7,
                spaceTop: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeading, {
                        asTag: "h2",
                        heading: "h2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlSpan/* default */.Z, {
                            html: data === null || data === void 0 ? void 0 : (ref = data.acf) === null || ref === void 0 ? void 0 : ref.textSectionsTitle
                        })
                    }),
                    (data === null || data === void 0 ? void 0 : (ref1 = data.acf) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.textSections) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && (data === null || data === void 0 ? void 0 : (ref3 = data.acf) === null || ref3 === void 0 ? void 0 : ref3.textSections.map(function(row, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextSection_Grid, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridLeftColumn, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlSpan/* default */.Z, {
                                                html: row.title
                                            })
                                        }),
                                        isTabletAndUp && (row === null || row === void 0 ? void 0 : row.wizzard) && row.wizzard.trim() !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Wizard, {
                                            bend: "up right",
                                            left: "0%",
                                            top: "100px",
                                            bottom: "auto",
                                            width: "80%",
                                            position: "relative",
                                            inView: true,
                                            inViewDelay: 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlSpan/* default */.Z, {
                                                html: row.wizzard
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accessible, {
                                        simple: row.textSimple,
                                        children: row.text
                                    })
                                })
                            ]
                        }, "textrow-".concat(index));
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAbove/* default */.Z, {
                        breakpoint: "tablet",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wizard, {
                            bend: "down right",
                            left: "0%",
                            bottom: "0px",
                            width: "20%",
                            inView: true,
                            inViewDelay: 1,
                            children: "Select one of the 6 conditions to find out more."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayBelow/* default */.Z, {
                        breakpoint: "tablet",
                        style: {
                            marginBottom: "var(--size-8)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wizard, {
                            bend: "down below",
                            left: "0%",
                            bottom: "0px",
                            width: "80%",
                            inView: true,
                            inViewDelay: 1,
                            children: "Select one of the 6 conditions to find out more."
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/ui/StaticSvgs.tsx
var StaticSvgs = __webpack_require__(1675);
;// CONCATENATED MODULE: ./components/content/About.tsx

function About_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: white;\n  font-size: 0.85em;\n\n  & > div > div > div:first-child {\n    margin-bottom: var(--size-6);\n  }\n\n  ",
        " {\n    padding-bottom: var(--size-7);\n\n    & > div > div > div:first-child {\n      margin-bottom: var(--size-2);\n    }\n  }\n\n  h2 {\n    ",
        "\n    ",
        "\n    font-weight: bold;\n    color: white;\n    font-size: calc(var(--text-h3-font-size) * 0.8);\n\n    ",
        " {\n      font-size: var(--text-h3-font-size);\n    }\n  }\n\n  p {\n    max-width: 100%;\n    margin: var(--size-3) 0;\n\n    ",
        " {\n      max-width: 80%;\n    }\n  }\n\n  .button {\n    margin-left: 0;\n\n    &:hover {\n      margin-left: 0;\n    }\n  }\n\n  & .tools {\n    margin: var(--size-4) 0;\n\n    & a {\n      color: white;\n      display: flex;\n    }\n\n    .labElement {\n      float: left;\n      margin: 0 10px 0 0;\n    }\n\n    .labElement + span {\n      margin: auto 0;\n      padding-bottom: 5px;\n    }\n  }\n"
    ]);
    About_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function About_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    height: auto;\n    margin-bottom: calc(0px - var(--size-6));\n\n    .infoboxes {\n      height: auto;\n    }\n  }\n\n  ",
        " {\n    margin-bottom: calc(",
        " * 0.25 * -0.5);\n\n    .infoboxes {\n      height: calc(",
        " / 4);\n      // overlap a third of the box to the top\n      margin-top: calc(",
        " * 0.25 * -0.5);\n    }\n  }\n\n  ",
        " {\n    margin-bottom: calc(var(--size-page-max-width) * 0.25 * -0.5);\n    .infoboxes {\n      height: calc(var(--size-page-max-width) * 0.25);\n      margin-top: calc(var(--size-page-max-width) * 0.25 * -0.5);\n    }\n  }\n"
    ]);
    About_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function About_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 0%;\n  padding-bottom: ",
        ";\n  font-size: 0.85em;\n  width: ",
        ";\n  margin: 0 auto;\n\n  ",
        " {\n    width: auto;\n    padding-bottom: 100%;\n  }\n\n  & svg {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    z-index: 0;\n\n    g {\n      fill: #fff;\n      stroke: #707070;\n      stroke-width: 1;\n    }\n  }\n\n  & h3,\n  & p,\n  & a {\n    z-index: 1;\n    position: relative;\n    padding: calc(",
        " + 10px) ",
        ";\n\n    ",
        " {\n      padding: calc(",
        " + 10px) ",
        ";\n    }\n\n    ",
        " {\n      padding: calc(",
        " + 10px) ",
        ";\n    }\n  }\n\n  h3 {\n    ",
        "\n    color: var(--color-text);\n    font-weight: 700;\n    font-size: calc(var(--text-body-font-size) * 0.8);\n    padding-bottom: 0;\n    margin: 0;\n  }\n\n  & p {\n    padding-top: 20px;\n    padding-bottom: 0;\n    font-size: calc(var(--text-body-font-size) * 0.85);\n    color: var(--color-text-muted);\n    margin: 0;\n    max-width: 100%;\n  }\n\n  & a {\n    padding-top: 20px;\n    padding-bottom: 0;\n    text-align: right;\n    display: block;\n    ",
        "\n    color: var(--color-text-muted);\n    font-weight: 700;\n    font-size: 0.9em;\n\n    opacity: 0.7;\n\n    &:hover {\n      opacity: 1;\n    }\n\n    svg {\n      height: 0.8em;\n      position: relative;\n      width: auto;\n      top: 0.02em;\n\n      path {\n        fill: var(--color-text-muted);\n      }\n    }\n  }\n"
    ]);
    About_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function About_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: var(--size-gutter-width);\n  grid-template-rows: auto;\n\n  ",
        " {\n    grid-template-columns: repeat(",
        ", 1fr);\n  }\n\n  &.infoboxes {\n    grid-template-rows: repeat(\n      ",
        ",\n      calc(",
        " + var(--size-3))\n    );\n\n    // Two by two\n    ",
        " {\n      grid-template-columns: repeat(calc(",
        " / 2), 1fr);\n      grid-template-rows: auto;\n    }\n\n    // Four in a row\n    ",
        " {\n      grid-template-columns: repeat(",
        ", 1fr);\n    }\n  }\n"
    ]);
    About_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











var pageContainerWidth = "(100vw - 2 * var(--size-page-margin))";
var mobileBoxSize = "calc(".concat(pageContainerWidth, " * 0.9)");
var boxPadding = "30px";
var boxPaddingMobile = "10vw";
var boxPaddingTablet = "5vw";
var AboutContainer = (0,styled_components_browser_esm/* default */.ZP)(PageMargins/* PageMargins */.vf).withConfig({
    componentId: "sc-fd6b3f95-0"
})(About_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var theme = param.theme;
    return theme.textStyle("h3");
}, function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
});
var InfoboxesContainer = (0,styled_components_browser_esm/* default */.ZP)(PageMargins/* PageMargins */.vf).withConfig({
    componentId: "sc-fd6b3f95-1"
})(About_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.desktop;
}, pageContainerWidth, pageContainerWidth, pageContainerWidth, function(param) {
    var theme = param.theme;
    return theme.breakpoints.screen;
});
var Infobox = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-fd6b3f95-2"
})(About_templateObject2(), mobileBoxSize, mobileBoxSize, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, boxPaddingMobile, boxPaddingMobile, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, boxPaddingTablet, boxPaddingTablet, function(param) {
    var theme = param.theme;
    return theme.breakpoints.desktop;
}, boxPadding, boxPadding, function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
}, function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
});
var About_Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fd6b3f95-3"
})(About_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var col = param.col;
    return col;
}, function(param) {
    var col = param.col;
    return col;
}, mobileBoxSize, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var col = param.col;
    return col;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.desktop;
}, function(param) {
    var col = param.col;
    return col;
});
var About = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var config = (0,ConfigContextProvider/* useConfigContext */.q)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContainer, {
                bgColor: "var(--color-piai-interface)",
                spaceTop: 6,
                spaceBottom: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(About_Grid, {
                    col: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlSpan/* default */.Z, {
                                        html: data === null || data === void 0 ? void 0 : (ref = data.acf) === null || ref === void 0 ? void 0 : ref.footerAbout.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlDiv/* default */.Z, {
                                    html: data === null || data === void 0 ? void 0 : (ref1 = data.acf) === null || ref1 === void 0 ? void 0 : ref1.footerAbout.text
                                }),
                                (data === null || data === void 0 ? void 0 : (ref2 = data.acf) === null || ref2 === void 0 ? void 0 : ref2.footerAbout.linkLabel) && (data === null || data === void 0 ? void 0 : (ref3 = data.acf) === null || ref3 === void 0 ? void 0 : ref3.footerAbout.linkLabel.trim()) && (data === null || data === void 0 ? void 0 : (ref4 = data.acf) === null || ref4 === void 0 ? void 0 : ref4.footerAbout.linkUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* LinkButton */.Qj, {
                                    href: data === null || data === void 0 ? void 0 : (ref5 = data.acf) === null || ref5 === void 0 ? void 0 : ref5.footerAbout.linkUrl,
                                    target: "_blank",
                                    rel: "norefferer",
                                    className: "button",
                                    children: data === null || data === void 0 ? void 0 : (ref6 = data.acf) === null || ref6 === void 0 ? void 0 : ref6.footerAbout.linkLabel
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlSpan/* default */.Z, {
                                        html: data === null || data === void 0 ? void 0 : (ref7 = data.acf) === null || ref7 === void 0 ? void 0 : ref7.footerTools.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlDiv/* default */.Z, {
                                    html: data === null || data === void 0 ? void 0 : (ref8 = data.acf) === null || ref8 === void 0 ? void 0 : ref8.footerTools.text
                                }),
                                (config === null || config === void 0 ? void 0 : (ref9 = config.tools) === null || ref9 === void 0 ? void 0 : ref9.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(About_Grid, {
                                    col: 2,
                                    className: "tools",
                                    children: config === null || config === void 0 ? void 0 : config.tools.map(function(tool, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            passHref: true,
                                            href: "/tool/".concat(tool.slug),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabElement/* LabElement */.c, {
                                                        shortHandle: tool.iconShort,
                                                        longText: tool.iconLong,
                                                        color: "white",
                                                        hoverColor: "#ffffffaa",
                                                        size: 1.6
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: tool.description
                                                    })
                                                ]
                                            })
                                        }, "tool-".concat(index));
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoboxesContainer, {
                bgColor: "var(--color-light-grey)",
                spaceTop: 6,
                spaceBottom: 6,
                children: (data === null || data === void 0 ? void 0 : (ref10 = data.acf) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.boxes) === null || ref11 === void 0 ? void 0 : ref11.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(About_Grid, {
                    col: data.acf.boxes.length,
                    className: "infoboxes",
                    children: data.acf.boxes.map(function(box, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Infobox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticSvgs/* BoxSvgs */.ho, {
                                    i: index + 1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: box.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: box.text
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: box.linkUrl,
                                    rel: "noreferrer nofollow",
                                    target: "_blank",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticSvgs/* Chevron */.Tt, {}),
                                        " ",
                                        box.linkLabel
                                    ]
                                })
                            ]
                        }, "box-".concat(index));
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/ui/AspectRatio.tsx
var AspectRatio = __webpack_require__(1257);
;// CONCATENATED MODULE: ./components/content/Accordion.tsx
/* eslint-disable react/jsx-key */ 
function Accordion_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: calc(var(--size-gutter-width) * 2);\n  position: relative;\n  margin-bottom: var(--size-5);\n\n  // Create Pillar grid and adjust margin bottom\n  // depending on the height of the absolutly positioned\n  // detail box below\n\n  ",
        " {\n    gap: var(--size-gutter-width);\n    grid-template-columns: auto auto;\n    grid-auto-rows: calc(",
        " / 2);\n\n    ",
        "\n  }\n\n  ",
        " {\n    grid-template-columns: auto auto auto;\n    grid-auto-rows: calc(",
        " / 3);\n  }\n\n  ",
        " {\n    grid-template-columns: repeat(6, 1fr);\n    grid-auto-rows: auto;\n    gap: calc(var(--size-gutter-width) * 1);\n    margin-left: calc(0px - var(--size-page-margin) / 2);\n    margin-right: calc(0px - var(--size-page-margin) / 2);\n\n    ",
        "\n  }\n"
    ]);
    Accordion_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Accordion_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: left;\n  display: block;\n  height: ",
        ";\n  width: ",
        ";\n  margin: 0 auto;\n  position: relative;\n\n  ",
        ' {\n    height: 100%;\n    width: unset;\n    margin: unset;\n  }\n\n  & svg.box {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    z-index: -1;\n  }\n\n  &[aria-expanded="true"] svg.box g {\n    stroke-width: 3;\n    stroke: var(--color-piai-interface);\n  }\n\n  & h3,\n  & p {\n    padding: calc(',
        " + 10px) ",
        ";\n\n    ",
        " {\n      padding: calc(",
        " + 10px) ",
        ";\n    }\n\n    ",
        " {\n      padding: calc(",
        " + 10px) ",
        ";\n    }\n  }\n\n  & h3 {\n    padding-bottom: 0;\n    ",
        " {\n      font-size: calc(var(--text-h3-font-size) * 0.6);\n    }\n  }\n\n  & p {\n    padding-top: 10px;\n    font-size: calc(var(--text-body-font-size));\n    font-family: var(--text-body-font-family);\n\n    color: var(--color-text-muted);\n\n    ",
        " {\n      font-size: calc(var(--text-body-font-size) * 0.75);\n      font-family: var(--font-family-narrow);\n    }\n  }\n\n  & svg.arrow {\n    position: absolute;\n    height: 50px;\n    bottom: calc(((60px - var(--size-7)) / 2) - 50px);\n    left: 42%;\n    display: block;\n\n    ",
        " {\n      height: 100px;\n      bottom: calc(((100px - var(--size-7)) / 2) - 100px);\n      display: none;\n    }\n\n    ",
        " {\n      height: 100px;\n      bottom: calc(((100px - var(--size-7)) / 2) - 100px);\n      display: block;\n    }\n  }\n"
    ]);
    Accordion_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Accordion_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  left: 0;\n  margin-top: var(--size-7);\n\n  ",
        " {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    margin-top: var(--size-2);\n  }\n\n  ",
        " {\n    margin-top: var(--size-7);\n  }\n\n  & svg.frame {\n    position: absolute;\n    width: calc(100% + 2 * var(--size-4));\n    // height: 100%;\n    top: 0;\n    left: calc(0px - var(--size-4));\n    z-index: -1;\n\n    ",
        " {\n      width: 100%;\n      left: 0;\n    }\n\n    g {\n      fill: #f5f8f9;\n      stroke: #707070;\n      stroke-width: 1;\n\n      ",
        " {\n        fill: none;\n      }\n    }\n  }\n"
    ]);
    Accordion_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Accordion_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: var(--size-gutter-width);\n  padding: var(--size-4);\n\n  & > div:last-child {\n    ",
        "\n  }\n\n  ",
        " {\n    grid-template-columns: 3fr 1fr;\n  }\n"
    ]);
    Accordion_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Accordion_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  font-weight: 700;\n  font-size: calc(var(--text-body-font-size) * 0.8);\n  margin: 0;\n\n  section & {\n    padding: var(--size-5) var(--size-4) 0;\n  }\n"
    ]);
    Accordion_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Accordion_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  font-size: calc(var(--text-h2-font-size) * 0.85);\n  margin: var(--size-2) var(--size-4) var(--size-2);\n"
    ]);
    Accordion_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}











var Accordion_boxPadding = "20px";
var Accordion_boxPaddingMobile = "10vw";
var Accordion_boxPaddingTablet = "5vw";
var Accordion_pageContainerWidth = "calc(100vw - 2 * var(--size-page-margin))";
var Accordion_mobileBoxSize = "calc(".concat(Accordion_pageContainerWidth, " * 0.9)");
//
//   Styling 5 pillars
// __________________________________
var Pillars = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-753f8b8b-0"
})(Accordion_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, Accordion_pageContainerWidth, function(param) {
    var marginBottom = param.marginBottom;
    return marginBottom && marginBottom > 0 ? "\n      margin-bottom: calc(".concat(marginBottom, "px + var(--size-2) + var(--size-6));\n      ") : "margin-bottom: var(--size-5)";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, Accordion_pageContainerWidth, function(param) {
    var theme = param.theme;
    return theme.breakpoints.desktop;
}, function(param) {
    var marginBottom = param.marginBottom;
    return marginBottom && marginBottom > 0 ? "\n      margin-bottom: calc(".concat(marginBottom, "px + var(--size-7) + var(--size-6));\n      ") : "margin-bottom: var(--size-5)";
});
var ToggleBox = (0,styled_components_browser_esm/* default */.ZP)(Button/* ButtonNormalized */.lr).withConfig({
    componentId: "sc-753f8b8b-1"
})(Accordion_templateObject1(), Accordion_mobileBoxSize, Accordion_mobileBoxSize, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, Accordion_boxPaddingMobile, Accordion_boxPaddingMobile, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, Accordion_boxPaddingTablet, Accordion_boxPaddingTablet, function(param) {
    var theme = param.theme;
    return theme.breakpoints.desktop;
}, Accordion_boxPadding, Accordion_boxPadding, function(param) {
    var theme = param.theme;
    return theme.breakpoints.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.desktop;
});
//
//   Styling detail box
// __________________________________
var Details = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-753f8b8b-2"
})(Accordion_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var Columns = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-753f8b8b-3"
})(Accordion_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.applyMixin("monospace");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
});
//
//   Headline styling
// __________________________________
var Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-753f8b8b-4"
})(Accordion_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
});
var Headline = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-753f8b8b-5"
})(Accordion_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.textStyle("h2");
});
var Accordion = function(param) {
    var data = param.data;
    var ref, ref1;
    var ref2 = (0,react.useState)(7), activeIndex = ref2[0], setActiveIndex = ref2[1];
    var ref3 = (0,react.useState)(0), height = ref3[0], setHeight = ref3[1];
    var boxesRefs = (0,react.useRef)(new Array());
    var isTabletAndUp = (0,CssVarsState/* useCssVarsStateIsTabletAndUpState */.kH)();
    // Update hight and scroll to details
    // when pillars get (de)selected (i.e. activeIndex changes)
    (0,react.useEffect)(function() {
        if (activeIndex < 6) {
            setHeight(boxesRefs.current[activeIndex].clientHeight);
            boxesRefs.current[activeIndex].scrollIntoView({
                behavior: "smooth",
                block: isTabletAndUp ? "nearest" : "start"
            });
        } else setHeight(0);
    }, [
        activeIndex,
        isTabletAndUp
    ]);
    if (!(data === null || data === void 0 ? void 0 : (ref = data.acf) === null || ref === void 0 ? void 0 : (ref1 = ref.conditions) === null || ref1 === void 0 ? void 0 : ref1.length)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMargins/* default */.ZP, {
        spaceBottom: 4,
        spaceTop: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pillars, {
            marginBottom: height,
            children: data.acf.conditions.map(function(pillar, index) {
                var ref, ref1;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleBox, {
                            id: "pillar-header-".concat(index),
                            "aria-expanded": activeIndex === index ? "true" : "false",
                            "aria-controls": "pillar-panel-".concat(index),
                            onClick: function() {
                                activeIndex === index ? setActiveIndex(6) : setActiveIndex(index);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AspectRatio/* AspectRatio */.o, {
                                    ratio: "1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticSvgs/* BoxSvgs */.ho, {
                                            i: index + 1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                            children: pillar.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlSpan/* default */.Z, {
                                                html: pillar.teaser
                                            })
                                        })
                                    ]
                                }),
                                activeIndex === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticSvgs/* Arrow */.Eh, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Details, {
                            id: "pillar-panel-".concat(index),
                            "aria-labelledby": "pillar-header-".concat(index),
                            hidden: activeIndex !== index,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                ref: function(element) {
                                    return boxesRefs.current[index] = element;
                                },
                                children: [
                                    isTabletAndUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticSvgs/* Frame */.RQ, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticSvgs/* Borders */.M3, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        children: pillar.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, {
                                        children: pillar.headline
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Columns, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accessible, {
                                                    simple: pillar.textSimple,
                                                    children: pillar.text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: (pillar === null || pillar === void 0 ? void 0 : (ref = pillar.sidebar) === null || ref === void 0 ? void 0 : ref.length) > 0 && (pillar === null || pillar === void 0 ? void 0 : (ref1 = pillar.sidebar) === null || ref1 === void 0 ? void 0 : ref1.map(function(note, nIndex) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlDiv/* default */.Z, {
                                                        html: note.sidebarElement
                                                    }, "pillar-".concat(index, "-sn-").concat(nIndex));
                                                }))
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }, "pillar-".concat(index));
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/content/Video.tsx

function Video_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-bottom: 56.25%;\n  overflow-bottom;\n  width: 100%;\n  height: 0px;\n  margin: var(--size-9) 0 0;\n\n  ",
        "{\n    margin: var(--size-8) 0 0;\n  }\n\n  .iframe{\n    overflow: hidden;\n    border: 0;\n    align-self: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    Video_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var VideoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cefa7cf3-0"
})(Video_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var Video = function(param) {
    var embedUrl = param.embedUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMargins/* Container */.W2, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wizard, {
                bend: "down right",
                left: "10%",
                bottom: "-80px",
                width: "20%",
                inView: true,
                inViewDelay: 1,
                children: "Watch our introduction to Public Interst AI"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: embedUrl,
                    allowFullScreen: true,
                    frameBorder: "0",
                    className: "iframe",
                    allow: "autoplay",
                    title: "Video"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/index.tsx










var Home = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9, ref10;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* default */.Z, {
                canonical: (ref9 = data === null || data === void 0 ? void 0 : (ref = data.yoast_head_json) === null || ref === void 0 ? void 0 : ref.canonical) !== null && ref9 !== void 0 ? ref9 : data === null || data === void 0 ? void 0 : (ref1 = data.yoast_head_json) === null || ref1 === void 0 ? void 0 : ref1.og_url,
                title: (ref10 = data === null || data === void 0 ? void 0 : (ref2 = data.yoast_head_json) === null || ref2 === void 0 ? void 0 : ref2.title) !== null && ref10 !== void 0 ? ref10 : data === null || data === void 0 ? void 0 : data.title,
                description: data === null || data === void 0 ? void 0 : (ref3 = data.yoast_head_json) === null || ref3 === void 0 ? void 0 : ref3.description,
                og: {
                    title: data === null || data === void 0 ? void 0 : (ref4 = data.yoast_head_json) === null || ref4 === void 0 ? void 0 : ref4.og_title,
                    url: data === null || data === void 0 ? void 0 : (ref5 = data.yoast_head_json) === null || ref5 === void 0 ? void 0 : ref5.og_url,
                    type: data === null || data === void 0 ? void 0 : (ref6 = data.yoast_head_json) === null || ref6 === void 0 ? void 0 : ref6.og_type,
                    siteName: data === null || data === void 0 ? void 0 : (ref7 = data.yoast_head_json) === null || ref7 === void 0 ? void 0 : ref7.og_site_name,
                    image: data === null || data === void 0 ? void 0 : (ref8 = data.yoast_head_json) === null || ref8 === void 0 ? void 0 : ref8.twitter_image
                },
                twitter: {
                    card: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                isHome: true,
                slideUpOnScroll: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                id: "content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro, {
                        data: data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tiles, {
                        data: data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
                        embedUrl: "https://www.youtube-nocookie.com/embed/U4uIFi5prsU"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSection, {
                        data: data,
                        id: "more"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
                        data: data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(About, {
                        data: data
                    })
                ]
            })
        ]
    });
};
Home.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutMain/* default */.Z, {
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [471,557,212,917,937,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);